export const asyncTimeout = (delay: number) =>
  new Promise(resolve => setTimeout(resolve, delay));
